export const COLLECTION_STORE = '1' // 收藏店铺
export const ONLY_MEMBER = '2' // 仅会员
